
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/palvelumme",
      function () {
        return require("private-next-pages/palvelumme.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/palvelumme"])
      });
    }
  